(function () {
  if (!document.body || !document.body.classList.contains('trout-trolling-gear')) return;
  if (document.getElementById('ca-trout-bundle-style-v2')) return;

  var style = document.createElement('style');
  style.id = 'ca-trout-bundle-style-v2';
  style.textContent = `
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail {
      background: #0d1b2e !important;
      color: #ffffff !important;
      overflow: hidden !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__inner {
      width: min(100%, 156rem) !important;
      margin: 0 auto !important;
      padding-right: clamp(1.6rem, 4vw, 5.6rem) !important;
      padding-left: clamp(1.6rem, 4vw, 5.6rem) !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__header {
      display: grid !important;
      grid-template-columns: minmax(0, 1.05fr) minmax(28rem, .65fr) !important;
      gap: clamp(1.8rem, 3vw, 4rem) !important;
      align-items: end !important;
      margin-bottom: clamp(2rem, 3vw, 3.6rem) !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__eyebrow,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__badge,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__feature-copy span {
      color: #f0c93a !important;
      font-family: var(--font-heading-family) !important;
      font-size: clamp(1.4rem, 1.2vw, 1.8rem) !important;
      font-weight: 900 !important;
      letter-spacing: .14em !important;
      line-height: 1 !important;
      text-transform: uppercase !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__header h2,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__feature-copy h3 {
      color: #ffffff !important;
      font-family: var(--font-heading-family) !important;
      font-size: clamp(3.8rem, 6vw, 8.8rem) !important;
      font-weight: 900 !important;
      letter-spacing: 0 !important;
      line-height: .95 !important;
      margin: .8rem 0 0 !important;
      text-transform: uppercase !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__subheading,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__subheading p,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__feature-copy p {
      color: #d7e0ea !important;
      font-size: clamp(1.6rem, 1.35vw, 2rem) !important;
      line-height: 1.45 !important;
      margin: 0 !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__feature {
      position: sticky !important;
      top: 1.8rem !important;
      display: flex !important;
      flex-direction: column !important;
      grid-template-columns: 1fr !important;
      gap: 1rem !important;
      align-items: start !important;
      max-width: 78rem !important;
      margin-bottom: 0 !important;
      padding: 0 !important;
      background: transparent !important;
      border: 0 !important;
      border-radius: 0 !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__feature-media {
      aspect-ratio: 16 / 7 !important;
      border-radius: 8px !important;
      overflow: hidden !important;
      background: #ffffff !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__feature-media img {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      display: block !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__feature-link {
      color: #f0c93a !important;
      font-family: var(--font-heading-family) !important;
      font-size: 1.45rem !important;
      font-weight: 900 !important;
      letter-spacing: .1em !important;
      line-height: 1 !important;
      text-decoration: underline !important;
      text-transform: uppercase !important;
      text-underline-offset: .35rem !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__feature-copy {
      display: grid !important;
      gap: 1rem !important;
      max-width: 62rem !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__feature-copy h3 {
      font-size: clamp(3rem, 3vw, 4.8rem) !important;
      margin: 0 !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__rail,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .product-grid {
      display: grid !important;
      grid-auto-flow: column !important;
      grid-auto-columns: minmax(32rem, 42rem) !important;
      grid-template-columns: none !important;
      gap: 2rem !important;
      overflow-x: auto !important;
      overscroll-behavior-inline: contain !important;
      scroll-snap-type: x proximity !important;
      padding: .2rem .2rem 1.8rem !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__card,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .product-card {
      display: flex !important;
      flex-direction: column !important;
      min-height: 100% !important;
      overflow: hidden !important;
      background: #ffffff !important;
      border: 1px solid #d8d3cc !important;
      border-radius: 8px !important;
      color: #0d1b2e !important;
      scroll-snap-align: start !important;
      box-shadow: none !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__badge {
      order: -2 !important;
      display: block !important;
      margin: 0 !important;
      padding: 1.6rem 2rem !important;
      background: #0d1b2e !important;
      color: #f0c93a !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__images,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .variant-grid {
      display: grid !important;
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
      gap: 1rem !important;
      padding: 1.6rem !important;
      background: #ffffff !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__images--4,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__images--5,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__images--6,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .variant-grid.six-up {
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__variant,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .variant {
      display: grid !important;
      gap: .8rem !important;
      align-content: start !important;
      padding: .8rem !important;
      background: #f7f7f7 !important;
      border: 1px solid #e3ded7 !important;
      border-radius: 8px !important;
      text-align: center !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__variant img,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .variant img {
      width: 100% !important;
      aspect-ratio: 1 / 1 !important;
      height: auto !important;
      object-fit: contain !important;
      display: block !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__variant span,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .variant span {
      color: #555555 !important;
      font-size: 1.2rem !important;
      font-weight: 800 !important;
      line-height: 1.15 !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__body,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .product-body {
      display: flex !important;
      flex: 1 1 auto !important;
      flex-direction: column !important;
      gap: 1.2rem !important;
      padding: 0 2rem 2rem !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__body h3,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .product-body h3 {
      color: #0d1b2e !important;
      font-family: var(--font-heading-family) !important;
      font-size: clamp(2.6rem, 2.5vw, 3.8rem) !important;
      font-weight: 900 !important;
      letter-spacing: 0 !important;
      line-height: .95 !important;
      margin: 0 !important;
      text-transform: uppercase !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__body p,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .product-body p {
      color: #555555 !important;
      font-size: 1.55rem !important;
      line-height: 1.4 !important;
      margin: 0 !important;
    }

    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__meta {
      display: grid !important;
      gap: .75rem !important;
      margin-top: .2rem !important;
      padding-top: 1.2rem !important;
      border-top: 1px solid #e3ded7 !important;
    }

    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__included {
      display: grid !important;
      gap: .7rem !important;
      margin: 0 !important;
      padding: 0 !important;
      border-top: 0 !important;
    }

    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__included strong {
      color: #0d1b2e !important;
      font-family: var(--font-heading-family) !important;
      font-size: 1.28rem !important;
      font-weight: 900 !important;
      letter-spacing: .1em !important;
      line-height: 1 !important;
      text-transform: uppercase !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__price,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .card-price {
      display: grid !important;
      gap: .4rem !important;
      margin-top: auto !important;
      padding-top: 1.2rem !important;
      border-top: 1px solid #e3ded7 !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__price span,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .card-price span {
      color: #0d1b2e !important;
      font-family: var(--font-heading-family) !important;
      font-size: 1.25rem !important;
      font-weight: 900 !important;
      letter-spacing: .12em !important;
      text-transform: uppercase !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__price strong,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .card-price strong {
      color: #c0272d !important;
      font-family: var(--font-heading-family) !important;
      font-size: clamp(3.4rem, 3vw, 4.6rem) !important;
      font-weight: 900 !important;
      line-height: 1 !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__price small,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .card-price div:last-child {
      display: flex !important;
      flex-wrap: wrap !important;
      gap: .8rem !important;
      align-items: center !important;
      color: #555555 !important;
      font-size: 1.45rem !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__price em,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .card-price em {
      color: #c0272d !important;
      font-family: var(--font-heading-family) !important;
      font-style: normal !important;
      font-weight: 900 !important;
      letter-spacing: .1em !important;
      text-transform: uppercase !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__actions,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .card-actions {
      display: grid !important;
      gap: .8rem !important;
      margin-top: .6rem !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__button,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .btn {
      display: inline-flex !important;
      min-height: 4.8rem !important;
      align-items: center !important;
      justify-content: center !important;
      padding: 1.2rem 1.8rem !important;
      background: #c0272d !important;
      border: 2px solid #c0272d !important;
      border-radius: 8px !important;
      color: #ffffff !important;
      font-family: var(--font-heading-family) !important;
      font-size: 1.6rem !important;
      font-weight: 900 !important;
      letter-spacing: .12em !important;
      line-height: 1 !important;
      text-align: center !important;
      text-decoration: none !important;
      text-transform: uppercase !important;
    }
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__button--secondary,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .btn.outline {
      background: #ffffff !important;
      border-color: #0d1b2e !important;
      color: #0d1b2e !important;
    }

    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__stock {
      color: #16833a !important;
      font-family: var(--font-heading-family) !important;
      font-size: 1.28rem !important;
      font-weight: 900 !important;
      letter-spacing: .1em !important;
      line-height: 1 !important;
      margin: 0 !important;
      text-transform: uppercase !important;
    }

    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__stock--low-stock {
      color: #b26f00 !important;
    }

    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__stock--out-of-stock {
      color: #9f1f25 !important;
    }

    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__meta > p.ca-manual-bundle-rail__stock--in_stock,
    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__meta > p.ca-manual-bundle-rail__stock--in-stock {
      color: #16833a !important;
    }
    @media (max-width: 989px) {
      body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__header,
      body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__feature {
        grid-template-columns: 1fr !important;
      }
      body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__rail,
      body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .product-grid {
        grid-auto-columns: minmax(29rem, 86vw) !important;
      }
    }

    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__header {
      grid-template-columns: 1fr !important;
      max-width: 112rem !important;
      align-items: start !important;
      gap: 1.4rem !important;
    }

    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__header h2 {
      max-width: 90rem !important;
    }

    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__subheading {
      max-width: 78rem !important;
    }

    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__content {
      display: grid !important;
      grid-template-columns: 1fr !important;
      gap: clamp(1.8rem, 2.4vw, 3rem) !important;
    }

    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__feature {
      grid-template-columns: 1fr !important;
      min-height: 0 !important;
      max-width: 78rem !important;
      margin-bottom: 0 !important;
      padding: 0 !important;
      background: transparent !important;
      border: 0 !important;
    }

    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__feature-media {
      aspect-ratio: 16 / 7 !important;
      min-height: 0 !important;
    }

    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__feature-copy {
      align-content: center !important;
      max-width: 72rem !important;
    }

    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__feature-copy h3 {
      max-width: 62rem !important;
      font-size: clamp(2.8rem, 3.1vw, 4.6rem) !important;
      line-height: .96 !important;
    }

    body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__section-button {
      align-self: start !important;
      width: auto !important;
      min-width: 15rem !important;
      max-width: 18rem !important;
      min-height: 4.8rem !important;
      padding: 1.2rem 1.6rem !important;
      white-space: normal !important;
    }

    @media (max-width: 989px) {
      body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__feature {
        grid-template-columns: 1fr !important;
      }

      body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__section-button {
        grid-column: 1 / -1 !important;
        justify-self: start !important;
      }
    }

    @media (max-width: 640px) {
      body.trout-trolling-gear .ca-manual-bundle-rail.ca-manual-bundle-rail .ca-manual-bundle-rail__feature {
        grid-template-columns: 1fr !important;
      }
    }
  `;

  document.head.appendChild(style);

  function getProductPath(href) {
    if (!href || href.indexOf('/products/') === -1) return '';

    try {
      var url = new URL(href, window.location.origin);
      var match = url.pathname.match(/\/products\/[^/]+/);
      return match ? match[0] : '';
    } catch (error) {
      var path = href.split('?')[0].split('#')[0];
      var fallbackMatch = path.match(/\/products\/[^/]+/);
      return fallbackMatch ? fallbackMatch[0] : '';
    }
  }

  function cleanBundleDetailsLinks() {
    document.querySelectorAll('.ca-manual-bundle-rail__card').forEach(function (card) {
      var details = card.querySelector('.ca-manual-bundle-rail__details');
      if (!details) return;

      var variantLinks = Array.prototype.slice.call(
        card.querySelectorAll('.ca-manual-bundle-rail__variant[href*="/products/"]')
      );
      var productPaths = new Set(
        variantLinks
          .map(function (link) { return getProductPath(link.getAttribute('href')); })
          .filter(Boolean)
      );
      var detailsPath = getProductPath(details.getAttribute('href'));

      if (variantLinks.length < 2 || productPaths.size !== 1 || !detailsPath || !productPaths.has(detailsPath)) {
        details.remove();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanBundleDetailsLinks);
  } else {
    cleanBundleDetailsLinks();
  }
})();
